import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import serviceFriendlyEndDateForAllDay from './serviceFriendlyEndDateForAllDay';
import cloneEvent from './cloneEvent';
import { startOfDay } from 'owa-datetime';

/**
 * Transforms an all day event in the "user friendly" form used within the
 * calendar compose form and returns a copy in the "service friendly" format
 * used outside of the calendar compose form.
 *
 * @param event
 * @returns
 */
export default function transformUserFriendlyAllDayToServiceFriendlyAllDay(
    event: CalendarEvent
): CalendarEvent {
    const clonedItem = cloneEvent(event);

    clonedItem.Start = startOfDay(event.Start);
    clonedItem.End = startOfDay(serviceFriendlyEndDateForAllDay(event.End));

    return clonedItem;
}
